import format from 'date-fns/format';
import { IRangeDatePiker, IRangeAPI } from 'interfaces/IRange';

export const formatRangeForDatePiker = (ranges: IRangeAPI[]): IRangeDatePiker[] => {
  return ranges.map((range) => ({
    startDate: new Date(range.from),
    endDate: new Date(range.to),
  }));
};

export const formatRangeForAPI = (ranges: IRangeDatePiker[]): IRangeAPI[] => {
  return ranges.map((range) => ({
    from: Date.parse(format(range.startDate, 'PP')),
    to: Date.parse(format(range.endDate, 'PP')),
  }));
};
